<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Unidades de Medidas</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-unidadesmedidas-nueva', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nuevo Unidad de Medida
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <form
                @submit="filterData"
                action="#"
                class="form-inline justify-content-sm-end"
              >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nombre de la Categoría</th>
                <th>Cantidad Unidades</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.nombre }}</td>
                <td>{{ current.cantidad_unidades }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UnidadMedidaService from "@/services/catalogos/UnidadMedidaService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      UnidadMedidaService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-unidadesmedidas-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-unidadesmedidas-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
